import Tabs from "./tabs.molecule";

export default Tabs;
